export function getInitials(name?: string) {
  let initials = '';
  if (!name.includes(' ')) {
    initials = name?.charAt(0);
  } else {
    initials = `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`;
  }

  return initials.toUpperCase();
}
